<template>
    <section class="interview-title light orange">
        <div class="css-grid">
            <div class="bg" style="background-image: url(/static/img/pages/interview-mohadesa.jpg)"></div>

            <div class="content-wrapper">
                <div class="content light orange">
                    <h3>Interview Mohadesa&nbsp;Bahrami</h3>
                    <h2>In 7 jaar van inburgeringscursus naar toegepaste psychologie</h2>
                    <button @click="openInterview">Lees het interview</button>
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped></style>

<script>
    import InterviewMohadesa from '@/app/pages/sub/InterviewMohadesa';

    export default {
        name: 'CarriereInterview',
        meta: {
            title: 'CarriereInterview',
            color: '#FE5D0B'
        },

        components: {
        },

        methods: {
            openInterview()
            {
                this.$emit( 'openOverlay', InterviewMohadesa );
            }
        }
    };
</script>
